import React from "react";

import { SnackSliderPlaceholderStyled as Styles } from "./SnackSlider.styles";
import { SnackSliderPlaceholderProps as Props } from "./SnackSlider.types";

const SnackSliderPlaceholder: React.FC<Props> = props => {
  const { numberProducts } = props;

  return (
    <Styles className="SnackSliderPlaceholder">
      {Array.from({ length: numberProducts }).map((_, index) => (
        <div
          key={index}
          className="SnackSliderPlaceholder__card loading-shine"
        />
      ))}
    </Styles>
  );
};

export default SnackSliderPlaceholder;
